import { buildType, currentAppVersion } from "@helpers/expo-extras";
import * as SentryReact from "@sentry/react";

// biome-ignore lint/suspicious/noExplicitAny: integration typing compatibility
export const reactNavigationIntegration: any = {
	registerNavigationContainer: (_ref: unknown) => undefined,
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const wrap = (component: any) => component;

export const getSentryInstance = () => SentryReact;

export const initSentry = () => {
	const dsn =
		"https://1374ef5814c84f11a93bbc41734e8c9a@o6329.ingest.us.sentry.io/5219043";

	if (!SentryReact.isInitialized()) {
		SentryReact.init({
			dsn,
			enabled: true,
			tracesSampleRate: 0,
			environment: process.env.NODE_ENV,
			replaysSessionSampleRate: 0,
			replaysOnErrorSampleRate: 0,
			_experiments: {
				profilesSampleRate: 0,
			},
			integrations: [
				SentryReact.replayIntegration({
					maskAllText: false,
					maskAllInputs: false,
					maxReplayDuration: 600000,
				}),
				SentryReact.browserTracingIntegration(),
			],
		});
		SentryReact.setTag("app", buildType);
		SentryReact.setTag("version", currentAppVersion);
	}
};

export const replayManager = () => {
	const replay = SentryReact.getReplay();

	return {
		startReplay: () => {
			if (replay) {
				try {
					replay.start();
				} catch (error) {
					SentryReact.captureException(new Error("Failed to start replay"), {
						extra: { error: JSON.stringify(error) },
					});
				}
			}
		},
		stopReplay: () => {
			if (replay) {
				try {
					replay.stop();
				} catch (error) {
					SentryReact.captureException(new Error("Failed to stop replay"), {
						extra: { error: JSON.stringify(error) },
					});
				}
			}
		},
	};
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
(globalThis as any).sentryInstance = getSentryInstance();
